<template>
    <v-container>
        <v-row class="text-center">
            <v-col cols="12">
                <v-img
                :src="require('../assets/logo.png')"
                class="my-0"
                contain
                height="50"
                />
            </v-col>
        </v-row>
        <v-card class="mx-auto" elevation-24 max-width="800">
          <v-form ref="Step3" v-model="Step3" lazy-validation>
              <!-- <v-card-text> -->
              <h4 class="text-center" style="text-align: center; color: green">
                  Select Details for Tickets
              </h4>
              <p></p>
              <!-- Pick Competition -->
              <v-select
                  v-model="selCompetition"
                  :items="Comps"
                  item-text="Name"
                  label="Competition"
                  placeholder="Click to select Competition"
                  prepend-icon="mdi-basketball"
                  @change="loadTeams"
                  :rules="[(v) => !!v || 'Competition is required']"
                  return-object
              />
              <!-- Pick Teams -->
              <v-select
                  v-model="selTeam"
                  :items="Teams"
                  item-text="Detail"
                  label="Team"
                  placeholder="Click to select Team"
                  prepend-icon="mdi-microsoft-teams"
                  @change="loadGames"
                  :rules="[(v) => !!v || 'Team is required']"
                  return-object
              />
              <!-- Pick People -->
              <v-select
                  v-model="selPeople"
                  :items="People"
                  item-text="person"
                  label="People"
                  multiple
                  no-data-text="No People Loaded"
                  placeholder="Click to select People"
                  prepend-icon="mdi-account-multiple"
                  :rules="[(v) => (Array.isArray(v) && v.length > 0) || 'You must select atleast one Person']"
                  return-object
              >
              <template v-slot:prepend-item>
                    <v-list-item
                    ripple
                    @mousedown.prevent
                    @click="togglePeople"
                    >
                    <v-list-item-action>
                        <v-icon :color="selPeople.length > 0 ? 'indigo darken-4' : ''">
                        {{ iconPeople }}
                        </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                        Select All
                        </v-list-item-title>
                    </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                </template>
                <template v-slot:append-item>
                  <v-divider class="mb-2"></v-divider>
                  <v-list-item disabled>
                  <v-list-item-avatar color="grey lighten-3">
                      <v-icon>
                      mdi-account
                      </v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content v-if="likesAllPeople">
                      <v-list-item-title>
                      You've selected all People
                      </v-list-item-title>
                  </v-list-item-content>

                  <v-list-item-content v-else-if="likesSomePeople">
                      <v-list-item-title>
                      You've selected 
                      </v-list-item-title>
                      <v-list-item-subtitle>
                      {{ selPeople.length }} People
                      </v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-content v-else>
                      <v-list-item-title>
                      You have not selected any People
                      </v-list-item-title>
                      <v-list-item-subtitle>
                      Go ahead, make a selection above!
                      </v-list-item-subtitle>
                  </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
              <!-- Pick Games -->
              <v-select
                  v-if="selCompetition && selCompetition.Pricing === 'Per Game'"
                  v-model="selGames"
                  :items="Games"
                  item-text="Display"
                  label="Games"
                  multiple
                  placeholder="Click to select Games"
                  prepend-icon="mdi-basketball-hoop-outline"
                  :rules="(selCompetition && selCompetition.Pricing === 'Per Game' ? [(v) => (Array.isArray(v) && v.length > 0) || 'You must select atleast one Game'] : [])"
                  return-object
              >
                <template v-slot:prepend-item>
                    <v-list-item
                    ripple
                    @mousedown.prevent
                    @click="toggleGames"
                    >
                    <v-list-item-action>
                        <v-icon :color="selGames.length > 0 ? 'indigo darken-4' : ''">
                        {{ iconGames }}
                        </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                        Select All
                        </v-list-item-title>
                    </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                </template>
                <template v-slot:append-item>
                  <v-divider class="mb-2"></v-divider>
                  <v-list-item disabled>
                  <v-list-item-avatar color="grey lighten-3">
                      <v-icon>
                      mdi-ticket
                      </v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content v-if="likesAllGames">
                      <v-list-item-title>
                      You've selected all Games
                      </v-list-item-title>
                  </v-list-item-content>

                  <v-list-item-content v-else-if="likesSomeGames">
                      <v-list-item-title>
                      You've selected 
                      </v-list-item-title>
                      <v-list-item-subtitle>
                      {{ selGames.length }} Games
                      </v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-content v-else>
                      <v-list-item-title>
                      You have not selected any Games
                      </v-list-item-title>
                      <v-list-item-subtitle>
                      Go ahead, make a selection above!
                      </v-list-item-subtitle>
                  </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
              <!-- Pick Days -->
              <v-select
                  v-if="selCompetition && selCompetition.Pricing === 'Per Day'"
                  v-model="selDays"
                  :items="Days"
                  item-text="day"
                  label="Days"
                  multiple
                  prepend-icon="mdi-calendar-outline"
                  placeholder="Click to select Days"
                  :rules="(selCompetition && selCompetition.Pricing === 'Per Day' ? [(v) => (Array.isArray(v) && v.length > 0) || 'You must select atleast one Day'] : [])"
                  return-object
              >
              <template v-slot:prepend-item>
                  <v-list-item
                  ripple
                  @mousedown.prevent
                  @click="toggle"
                  >
                  <v-list-item-action>
                      <v-icon :color="selDays.length > 0 ? 'indigo darken-4' : ''">
                      {{ icon }}
                      </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                      <v-list-item-title>
                      Select All
                      </v-list-item-title>
                  </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
              </template>
              <template v-slot:append-item>
                  <v-divider class="mb-2"></v-divider>
                  <v-list-item disabled>
                  <v-list-item-avatar color="grey lighten-3">
                      <v-icon>
                      mdi-ticket
                      </v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content v-if="likesAllDays">
                      <v-list-item-title>
                      You've selected all days
                      </v-list-item-title>
                  </v-list-item-content>

                  <v-list-item-content v-else-if="likesSomeDays">
                      <v-list-item-title>
                      You've selected 
                      </v-list-item-title>
                      <v-list-item-subtitle>
                      {{ selDays.length }} Days
                      </v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-content v-else>
                      <v-list-item-title>
                      You have not selected any Days
                      </v-list-item-title>
                      <v-list-item-subtitle>
                      Go ahead, make a selection above!
                      </v-list-item-subtitle>
                  </v-list-item-content>
                  </v-list-item>
              </template> 
              </v-select>
          </v-form>
        <v-card-actions>
        <v-btn :loading="loading" color="oug" text to="/step2">
          <v-icon>mdi-arrow-left-bold</v-icon>
          Back
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn :loading="loading" :disabled="!allItems" color="oug" text @click="Validate">
          Next
          <v-icon>mdi-arrow-right-bold</v-icon>
        </v-btn>
      </v-card-actions>
        </v-card>
         <v-row class="text-center">
            <v-col cols="12">
                <v-divider></v-divider>
                <h3 style="text-align: center; color: red">
                  If you are not seeing the competition you are expecting then please clear 
                  your browser history to see the latest competitions
                </h3>
                <!-- :disabled="!selCompetition" -->
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import db from "../data/Database";
import axios from "axios";
import functions from "../data/Functions"

    export default {
    data () {
      return {
        Step3: false,
        loading: false,
        selCompetition: null,
        selTeam: null,
        selPeople: [],
        selDays: [],
        selGames: [],
        Comps: [],
        Teams: [],
        Games: [],
        People: [],
        Days: [],
      }
    },
    created() {
      this.currentState = db.currentState.get(1, (result) =>
        this.loadState(result)
      );
    },

    methods: {
      loadState(result) {
        this.loadComps()
        this.currentState = result;
        db.people.toArray((result) => this.loadPeople(result));
      },
      loadComps() {
        this.Comps = [];
        const baseURL = "https://server.ownurgoal.net.au/gen/GetTicketEvents";
        axios
          .post(baseURL)
          .then((response) => {
            response.data.result.forEach(element => {
                this.Comps.push({
                  Name: element.Name,
                  Code: element.Code,
                  Gender: element.Gender,
                  Association: element.Association,
                  Adult: element.Adult,
                  Child: element.Child,
                  Pricing: element.Pricing,
                  Venue: element.Venue,
                  StartDate: element.StartDate,
                  EndDate: element.EndDate,
                  Days: [],
                })
            });
            this.Comps.forEach(comp => {
              const start = functions.formatDate(comp.StartDate, 'YYYY-MM-DD');
              const end = functions.formatDate(comp.EndDate, 'YYYY-MM-DD');
              let loop = start;
                while (loop <= end) {
                  comp.Days.push({ day: functions.formatDate(loop, 'ddd MMM DD YYYY'), date: functions.formatDate(loop, 'YYYY-MM-DD') })
                  loop = functions.formatDate(functions.addDays(loop, 1, 'day'), "YYYY-MM-DD")
                }
            })
          })
          .catch((error) => {
            console.log(error);
            this.error =
              "Error loading Games - please check details and try again";
          });
      },
      loadPeople(result) {
        this.People = [];
        result.forEach(element => {
          this.People.push(element)
        });
      },
      loadTeams() {
        this.selTeam = null
        let payload 
        this.Days = this.selCompetition.Days
        if (this.selCompetition.Gender.length > 0) {
          payload = {
            Competition_Id: this.selCompetition.Code,
            Gender: this.selCompetition.Gender == "Male" ? 18 : 19,
          };
        } else {
          payload = {
            Competition_Id: this.selCompetition.Code,
          };
        }
        this.Teams = [];
        const baseURL = "https://server.ownurgoal.net.au/tickets/teams/Gender";
        axios
          .post(baseURL, payload)
          .then((response) => {
            response.data.result.forEach(element => {
                this.Teams.push(element)
            });
          })
          .catch((error) => {
            console.log(error);
            this.error =
              "Error loading Games - please check details and try again";
          });
      },
      loadGames() {
      this.loading = true;
      let payload = {
        Competition: this.selCompetition.Code,
        Gender: this.selCompetition.Gender,
        Team: this.selTeam.Code_id,
      };
      this.Games = [];
      const baseURL = "https://server.ownurgoal.net.au/tickets/comp/games";
      axios
        .post(baseURL, payload)
        .then((response) => {
          response.data.result.forEach(element => {
            element.Display = this.calcDisplay(element)
            this.Games.push(element)
          });
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.error =
            "Error loading Games - please check details and try again";
        });
      },
      calcDisplay (el) {
        let Display = `${el.Date} ${el.Start_Time} `
        if (el.Home_Team_Name === this.selTeam.Detail) { Display += el.Away_Team_Name}
        if (el.Away_Team_Name === this.selTeam.Detail) { Display += el.Home_Team_Name}
        return Display
      },
      toggle () {
        this.$nextTick(() => {
          if (this.likesAllDays) {
            this.selDays = []
          } else {
            this.selDays = this.Days.slice()
          }
        })
      },
      toggleGames () {
        this.$nextTick(() => {
          if (this.likesAllGames) {
            this.selGames = []
          } else {
            this.selGames = this.Games.slice()
          }
        })
      },
      togglePeople () {
        this.$nextTick(() => {
          if (this.likesAllPeople) {
            this.selPeople = []
          } else {
            this.selPeople = this.People.slice()
          }
        })
      },
      Validate () {
        if (this.$refs.Step3.validate()) {
          let Total = this.calculatePrice()
          db.currentState.update(1, {
          Competition: this.selCompetition,
          Team: this.selTeam,
          People: this.selPeople,
          Days: this.selDays,
          Games: this.selGames,
          Amount: Total
        });
        this.$router.push("/pinpay");
        }
      },
      calculatePrice () {
        let Adults = 0, Children = 0, units = 0
        if (this.selCompetition.Pricing === 'Per Day') {units = this.selDays.length}
        if (this.selCompetition.Pricing === 'Per Game') {units = this.selGames.length}
        this.selPeople.forEach(element => {
          if (element.ticket === 'Adult') { Adults++}
          if (element.ticket === 'Child (6-17)') { Children++}
        });
        let price = (Adults * this.selCompetition.Adult * units) + (Children * this.selCompetition.Child * units)
        return price
      },
    },

    computed: {
      likesAllDays () {
        return this.selDays.length === this.Days.length
      },
      likesSomeDays () {
        return this.selDays.length > 0 && !this.likesAllDays
      },
      icon () {
        if (this.likesAllDays) return 'mdi-close-box'
        if (this.likesSomeDays) return 'mdi-minus-box'
        return 'mdi-checkbox-blank-outline'
      },
      likesAllGames () {
        return this.selGames.length === this.Games.length
      },
      likesSomeGames () {
        return this.selGames.length > 0 && !this.likesAllGames
      },
      iconGames () {
        if (this.likesAllGames) return 'mdi-close-box'
        if (this.likesSomeGames) return 'mdi-minus-box'
        return 'mdi-checkbox-blank-outline'
      },
      likesAllPeople () {
        return this.selPeople.length === this.People.length
      },
      likesSomePeople () {
        return this.selPeople.length > 0 && !this.likesAllPeople
      },
      iconPeople () {
        if (this.likesAllPeople) return 'mdi-close-box'
        if (this.likesSomePeople) return 'mdi-minus-box'
        return 'mdi-checkbox-blank-outline'
      },
      allItems () {
        let result = false
        if (
          this.selCompetition && this.selCompetition.Pricing === 'Per Day' && 
          this.selTeam && 
          this.selPeople && this.selPeople.length > 0 && 
          this.selDays && this.selDays.length > 0) { result = true}
        if (
          this.selCompetition && this.selCompetition.Pricing === 'Per Game' && 
          this.selTeam && 
          this.selPeople && this.selPeople.length > 0 && 
          this.selGames && this.selGames.length > 0) { result = true}
        return result
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>